export interface FileInventory {
  id?: string | number | null;
  url?: string;
}

/** True when a GraphQL FileInventory id is present (Guid string or leftover int). */
export function hasFileInventoryId(id: unknown): boolean {
  if (typeof id === 'number') {
    return Number.isFinite(id) && id > 0;
  }
  if (typeof id === 'string') {
    const trimmed = id.trim();
    return trimmed.length > 0 && trimmed !== '0';
  }
  return false;
}

/** Canonical string id, or null when missing. */
export function readFileInventoryId(id: unknown): string | null {
  if (typeof id === 'number' && Number.isFinite(id) && id > 0) {
    return String(id);
  }
  if (typeof id === 'string') {
    const trimmed = id.trim();
    return trimmed.length > 0 && trimmed !== '0' ? trimmed : null;
  }
  return null;
}
